<template>
  <b-modal :active="active" has-modal-card :on-cancel="onClose">
    <div class="add-step modal-content">
      <div class="box">
        <header class="title is-5">Add Step</header>
        <form class="add-step__form" @submit.prevent="addStepHandler">
          <b-field>
            <v-select
              v-model="type"
              :clearable="false"
              :options="options"
              placeholder="Step Type"
              :searchable="false"
            />
          </b-field>
          <b-field>
            <b-input
              v-model="name"
              icon="format-title"
              placeholder="Step Name"
              required
              type="text"
            />
          </b-field>
          <b-button
            class="is-fullwidth"
            :loading="tests.submitting || videos.submitting"
            native-type="submit"
            type="is-primary"
          >
            Add
          </b-button>
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  props: {
    active: Boolean,
    onClose: Function
  },
  data: function() {
    return {
      type: {},
      name: '',
      options: [
        {
          label: 'Video',
          value: 'videos'
        },
        {
          label: 'Test',
          value: 'tests'
        }
      ]
    };
  },
  computed: {
    ...mapState(['tests', 'videos'])
  },
  methods: {
    ...mapActions('tests', ['addTest']),
    ...mapActions('videos', ['addVideo']),
    async addStepHandler() {
      try {
        const payload = {
          data: { name: this.name },
          owner: 'concepts'
        };
        let newStepPath = '';
        if (this.type.value === 'videos') {
          await this.addVideo(payload);
          newStepPath = `videos/${this.videos.newVideoId}`;
        } else {
          await this.addTest(payload);
          newStepPath = `tests/${this.tests.newTestId}`;
        }
        this.onClose();
        this.reset();
        this.$buefy.toast.open({
          message: 'Step added successfully!',
          type: 'is-success'
        });
        this.$emit('added', newStepPath);
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to add step!',
          type: 'is-danger'
        });
      }
    },
    reset() {
      this.type = this.options[0];
      this.name = '';
    }
  },
  created() {
    this.reset();
  }
};
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins.sass';

.add-step {
  width: auto;

  &__form {
    @include tablet {
      min-width: 20rem;
    }
  }
}
</style>
